import VerifiedIcon from '@mui/icons-material/Verified';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import {Flag, Warning} from "@mui/icons-material";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';

export default function ActiveMember({client, style}) {

  return (
    <>
      {client?.openInvoice && <a href={'#'}
                                 onClick={(e)=>{
                                   e.preventDefault();
                                 }}
                                 style={{
                                   float: 'left',
                                   color: '#be6734'
                                 }}>
        <OverlayTrigger
          placement={'top'}
          delay={{show: 250, hide: 400}}
          overlay={
            <Tooltip style={{
              zIndex:'9999'
            }}>
              Open Invoice
            </Tooltip>
          }>
          <span><Warning/></span>
        </OverlayTrigger>
        &nbsp;
      </a>}

      {client?.openMemberInvoice && <a href={'#'}
                                       onClick={(e)=>{
                                         e.preventDefault();
                                       }}
                                       style={{
                                         float: 'left',
                                         color: '#e20c0c'
                                       }}>
        <OverlayTrigger
          placement={'top'}
          delay={{show: 250, hide: 400}}
          overlay={
            <Tooltip style={{
              zIndex:'9999'
            }}>
              Open Membership Invoice
            </Tooltip>
          }>
          <span><NotificationImportantIcon/></span>
        </OverlayTrigger>
        &nbsp;
      </a>}


      {client?.activeMember && <a href={'#'}
         onClick={(e)=>{
           e.preventDefault();
         }}
         style={style || {
           float: 'left',
         }}>
        <OverlayTrigger
          placement={'top'}
          delay={{show: 250, hide: 400}}
          overlay={
            <Tooltip style={{
              zIndex:'9999'
            }}>
              Active Membership
            </Tooltip>
          }>
          <span><VerifiedIcon/></span>
        </OverlayTrigger>
        &nbsp;
      </a>}
      {client?.flagged && <a href={'#'}
                                  onClick={(e)=>{
                                    e.preventDefault();
                                  }}
                                  style={style || {
                                    float: 'left',
                                  }}>
        <OverlayTrigger
          placement={'top'}
          delay={{show: 250, hide: 400}}
          overlay={
            <Tooltip style={{
              zIndex:'9999'
            }}>
              Flagged
            </Tooltip>
          }>
          <span><Flag /></span>
        </OverlayTrigger>
        &nbsp;
      </a>}

    </>
  );

}